import React from 'react';
import { Container } from 'react-bootstrap';
import './Important.css';
import { Link } from 'react-router-dom';

function Important  ()  {
    return (
        <div>
            <div className='container'>
            <p className='eda'>Explore Additional Resources</p>
            <img className='underline__svg' src='images/underline.svg' alt='underline'/>
            <p className='termsandconditions'>If you share your study materials with others, you may have a chance to rank among the top contributors. To accomplish this, follow these steps:
                <li> If you know of a YouTube channel that others should use, share its url with them. </li>
                <li>Share online resources and contribute</li> 
                <li> Assist young people so they can choose a decent college for their future</li> 
                <li>share helpful websites like gfg and stackoverflow so that it helps others and you may become a contributor</li> 
                <li>Share the program download link with others so that it will be helpful to them all and you can join the contributors. </li>
</p>
</div>
            <Container className='bg__img'>
                    <div class="row">
                        <div class="col">
                            <Link to="/TopContribuorsV">
                            <ul className='left__side__list'>
                                <li>
                                  <a href='' > <button className='left__side__list extra__items diagonal-hover'> <div className='content'> <i class="fa fa-users"></i> <br/>  Top Contributors </div> </button> </a> 
                                </li>
                            </ul>
                            </Link>
                        </div>

                        <div class="col">
                            <Link to="/YoutubeUrl">
                            <ul className='center__list'>
                                <li>
                                   <a href='' > <button className='left__side__list extra__items diagonal-hover'> <div className='content'>  <i class="fa-brands fa-youtube fa"></i> <br/> Youtube Channels for study </div> </button> </a>
                                </li>
                            </ul>
                            </Link>
                        </div>

                        <div class="col">
                            <Link to="WebsiteUrlV">
                            <ul className='center__list'>
                                <li>
                                   <a href='' > <button className='left__side__list extra__items diagonal-hover'> <div className='content'> <i class="fa-solid fa-link fa"></i> <br/> Website url </div> </button> </a>
                                </li>
                            </ul>
                            </Link>
                        </div>
                        </div>

                        <div class="row">
                        <div class="col">
                            <Link to="/OnlineToolV">
                            <ul className='center__list'>
                                <li>
                                   <a href='' > <button className='left__side__list extra__items diagonal-hover'> <div className='content'> <i class="fa-solid fa-gear fa"></i> <br/> Online Tools </div> </button> </a>
                                </li>
                            </ul>
                            </Link>
                        </div>

                        <div class="col">
                            <Link to="/CollegeReviewV">
                            <ul className='center__list'>
                                <li>
                                   <a href='' > <button className='left__side__list extra__items diagonal-hover'> <div className='content'> <i class="fa-solid fa-star" style={{color: '#e0fd08'}}></i> 
                                   <i class="fa-solid fa-star" style={{color: '#e0fd08'}}></i> 
                                   <i class="fa-solid fa-star" style={{color: '#e0fd08'}}></i> 
                                   <i class="fa-solid fa-star" style={{color: '#e0fd08'}}></i> 
                                   <i class="fa-regular fa-star" style={{color: '#242424'}}></i>
                                   <br/> College Review </div> </button> </a>
                                </li>
                            </ul>
                            </Link>
                        </div>
                        
                        <div class="col">
                            <Link to='/SoftwareDownloadV'>
                            <ul className='right__side__list'>
                                <li>
                                   <a href=''  > <button className='left__side__list extra__items diagonal-hover'> <div className='content'> <i class="fa-brands fa-uncharted fa"></i> <br/> Software Download </div> </button> </a>
                                </li>
                            </ul>
                            </Link>
                        </div>
                    </div>
            </Container> 
            <hr/>
        </div>
    );
}

export default Important;
// https://stackoverflow.com/questions/44970940/how-to-remove-warning-this-application-was-created-by-another-user-not-by-goog